module.exports = __webpack_public_path__ + "img/horizontal.3db26da1.png";